/**
 * Доля ядра публичного рендерера: строка «картинка слева от текста» у
 * заголовка и подзаголовка — слово владельца 21.10.2026 (задание
 * stylepack/title-side-image). Метки `case 'title'` и `case 'sub_title'`
 * остаются в ядре (`PublicBlockRenderer.tsx`), ядро в них только зовёт
 * `renderTitleSideImage(block, текст)`; тег блока, его стиль и обёртки ядра
 * остаются в ядре.
 *
 * Нет годного адреса или тип вне перечня — возвращается тот же узел текста,
 * разметка прежняя байт в байт. Картинка декоративная: `alt=""` и
 * `aria-hidden`, читалка читает только текст заголовка. Расчёт стиля —
 * `../titleSideImage.ts` (зеркало сервера, сторож концов на сервере).
 */
import type React from 'react';
import type { EditorBlock } from '@/store/editorSlice';
import {
  TITLE_SIDE_IMAGE_BLOCK_TYPES,
  titleSideImageParts,
} from '../titleSideImage';

export function renderTitleSideImage(
  block: EditorBlock,
  text: React.ReactNode,
): React.ReactNode {
  const parts = TITLE_SIDE_IMAGE_BLOCK_TYPES.has(block.type)
    ? titleSideImageParts(block)
    : null;
  if (!parts) return text;
  return (
    <span data-testid="title-side-image-row" style={parts.row}>
      <img
        src={parts.src}
        alt=""
        aria-hidden="true"
        decoding="async"
        style={parts.img}
      />
      <span style={parts.text}>{text}</span>
    </span>
  );
}
